import { createContext } from 'use-context-selector';

import { ConfirmationProps } from 'src/contexts/resizableWindow.context';
import { Maybe } from 'src/models';

export interface TModalContext {
  closeModal: (isSkipConfirmation?: boolean) => void;
  setVisibility: (isVisible: boolean) => void;
  setConfirmationProps: (props?: ConfirmationProps) => void;
  showConfirmation: (onCloseFn: () => void) => void;
  renderConfirmation: () => Maybe<JSX.Element>;
  isDisabledClosing?: boolean;
  isHideCloseButton?: boolean;
}

export const ModalContext = createContext({} as TModalContext);
